/* eslint-disable no-prototype-builtins */
// https://github.com/reactjs/redux/blob/master/docs/recipes/ReducingBoilerplate.md#generating-reducers
const createReducer = (initialState, handlers) => (
  state = initialState,
  action,
) => {
  if (handlers.hasOwnProperty(action.type)) {
    return handlers[action.type](state, action);
  }
  return state;
};

export default createReducer;



// WEBPACK FOOTER //
// ./src/utils/redux/reducer.js